<template>
  <div class="wrapper log-bg">
    <div class="header-area bg-transparent border-0">
      <div class="container-fluid">
        <div class="row">
          <div class="col-6">
            <a @click="$router.go(-1)" href="javascript:;">
              <span class="back-arrow mt-4"></span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="body-area pb-0">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="text-center pb-2">
              <img src="/static/img/logo.png" alt />
            </div>
          </div>

          <div class="col-12">
            <div class="warning fs-14 fc-6 py-2 px-3">{{ error }}</div>
            <button @click="sendCode" class="sign-button" v-if="activation_required">Yeni Kod Gönder</button>
            <input v-model="email" type="text" class="form-input" placeholder="E-posta adresin" />
            <input v-model="password" type="text" class="form-input" placeholder="Şifre" />
          </div>
          <div class="col-12 mb-0">
            <div class="row">
              <div class="col-6">
                <router-link
                  :to="{ name: 'ForgotPassword' }"
                  class="opak-button d-block fc-3 pr-0"
                >Şifremi Unuttum</router-link>
              </div>
              <div class="col-6">
                <button @click="login" class="confirm-button">Giriş Yap</button>
              </div>
            </div>
          </div>

          <div style="width: 100%; margin-top: 30px">
            <div class="col-12 mt-0">
              <router-link
                :to="{ name: 'Register' }"
                style="display:block; text-align:center;"
                class="sign-button"
              >Üye Ol</router-link>
            </div>
            <div class="col-12">
              <router-link
                :to="{ name: 'Home'}"
                style="display:block; text-align:center;"
                class="opak-button fc-2"
              >Üye Olmadan Devam Et</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Menu from "@/components/Menu";
import axios from "axios";
export default {
  name: "Login",
  components: {
    Footer,
    Menu,
    Header
  },
  data() {
    return {
      email: null,
      password: null,
      error: null,
      activation_required: false
    };
  },
  methods: {
    sendCode() {
      var data = new FormData();
      data.append("email", this.email);
      axios.post("uyelik/aktivasyon-gonder", data).then(res => {
        if (res.data.status == 200) {
          this.$message.success(res.data.message);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    login() {
      this.error = null;

      var data = new FormData();
      data.append("email", this.email);
      data.append("password", this.password);

      axios
        .post("uyelik/giris", data)
        .then(res => {
          if (res.data.StatusCode == 200) {
            axios
              .get("uyelik/hesap?token=" + res.data.Data.token)
              .then(res2 => {
                this.$store.state.user = res2.data.data;

                this.$store.commit("setUser", res2.data.data);

                localStorage.setItem("user", JSON.stringify(res2.data.data));

                var redir = localStorage.getItem("redir");

                if (redir === null) {
                  this.$router.push({ name: "Home" });
                } else {
                  var redir = JSON.parse(redir);
                  localStorage.removeItem("redir");
                  this.$router.push({
                    name: redir.name,
                    params: { ...redir.params }
                  });
                }
              });
          } else {
            this.error = res.data.Data[0];
            this.activation_required = res.data.activation_required;
          }
        })
        .catch(err => {});
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/Login.vue